import React from 'react';
import { Dialog, DialogContent, Grow, makeStyles, Paper, Typography } from '@material-ui/core';
import { Bold } from './UI/TextFormatters';
import { StopwatchTimerAnimated } from './UI/SVGAssets/SVGAssets';

const modalPaperStyles = makeStyles(theme => ({
  iconTab: {
    background: `radial-gradient(at bottom left, rgba(0,9,106,1) 0%, rgba(0,9,106,1) 100%)`,
    borderRadius: '30%',
    padding: '1.3em',
    top: -20,
    right: -20,
    width: 70,
    height: 70,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transform: 'rotate(45deg)',
  },
  icon: {
    position: 'absolute',
    transform: 'rotate(-45deg)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
  },
  dialogPaper: {
    background: `radial-gradient(at bottom left,${theme.palette.primary.main} 0%, rgba(0,9,106,1) 80%)`,
  },
}));

const ModalPaper = ({ children }) => {
  const classes = modalPaperStyles();
  return (
    <div style={{ position: 'relative' }}>
      <div className={classes.iconTab}>
        <div className={classes.icon}>
          <StopwatchTimerAnimated
            fillTransition
            strokeTransition
            fill="rgba(255,255,255,.6)"
            stroke="rgba(255,255,255,.5)"
            strokeWidth={10}
          />
        </div>
      </div>
      <Paper className={classes.dialogPaper}>{children}</Paper>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  backDrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    '@supports (backdrop-filter: blur(10px))': {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      backdropFilter: 'blur(10px)',
    },
  },
}));

const ExpiredSessionModal = ({ open }) => {
  const classes = useStyles();

  return (
    <Dialog
      TransitionComponent={Grow}
      disableBackdropClick
      transitionDuration={500}
      BackdropProps={{
        classes: {
          root: classes.backDrop,
        },
      }}
      PaperComponent={ModalPaper}
      maxWidth="sm"
      open={open}>
      <DialogContent>
        <div style={{ color: 'white' }}>
          <Typography variant="h6">
            <Bold>Sesión</Bold>
          </Typography>
          <div style={{ margin: '3em' }}>
            Su sesión ha expirado. Redirigiendo a login...
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
export default ExpiredSessionModal;
